export default __webpack_public_path__ + "static/media/hero-blob.7fe6f76b.png";